import { ThemeOptions } from "@mui/material";

const typography: ThemeOptions["typography"] = {
  fontFamily: '"GT Ultra"',
  h1: {
    fontFamily: '"GT Ultra Lloyds"',
    fontWeight: 700,
    fontSize: "2.5rem",
    letterSpacing: "-0.24px",
  },
  h2: {
    fontFamily: '"GT Ultra Lloyds"',
    fontWeight: 700,
    fontSize: "2rem",
    letterSpacing: "-0.24px",
  },
  h3: {
    fontFamily: '"GT Ultra Lloyds"',
    fontWeight: 700,
    fontSize: "1.5rem",
    letterSpacing: "-0.06px",
  },
  h4: {
    fontFamily: '"GT Ultra Lloyds"',
    fontWeight: 600,
    fontSize: "1.25rem",
    letterSpacing: "-0.06px",
  },
  h5: {
    fontFamily: '"GT Ultra Lloyds"',
    fontWeight: 600,
    fontSize: "1rem",
    letterSpacing: "-0.05px",
  },
  h6: {
    fontFamily: '"GT Ultra Lloyds"',
    fontWeight: 600,
    fontSize: "0.875rem",
    letterSpacing: "-0.05px",
  },
  subtitle1: { fontFamily: '"GT Ultra"', fontSize: "1.125rem", lineHeight: 1.5, fontWeight: 700 },
  body1: { fontFamily: '"GT Ultra"', fontSize: "1.125rem", lineHeight: 1.5, fontWeight: 400 },
  body2: { fontFamily: '"GT Ultra"', fontSize: "1rem", lineHeight: 1.57, fontWeight: 400 },
  button: { fontFamily: '"GT Ultra"', fontWeight: 600, textTransform: "none" },
  caption: { fontFamily: '"GT Ultra"', fontSize: "0.75rem", lineHeight: 1.66 },
  overline: {
    fontFamily: '"GT Ultra"',
    fontWeight: 600,
    fontSize: "0.75rem",
    letterSpacing: "0.5px",
  },
};

export default typography;
